export { getStoresServerAction } from 'next-flight-server-reference-proxy-loader?id=701d694ba45838d9d0be458c67688df7a20ade3826&name=getStoresServerAction!'